import { render } from "./MLink.vue?vue&type=template&id=4aa64c60"
import script from "./MLink.vue?vue&type=script&lang=js"
export * from "./MLink.vue?vue&type=script&lang=js"

import "./MLink.vue?vue&type=style&index=0&id=4aa64c60&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__